// extracted by mini-css-extract-plugin
export default {"data-row-title":"GenericDataRow_data-row-title__n2uWB","data-row-field":"GenericDataRow_data-row-field__+gXg5","container":"GenericDataRow_container__NLgpa"};